import { render } from "./DeadlinesSchemes.vue?vue&type=template&id=3053f414"
import script from "./DeadlinesSchemes.vue?vue&type=script&lang=js"
export * from "./DeadlinesSchemes.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\Vind\\Vind\\VindFront\\VindFrontVueApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__